export default __webpack_public_path__ + "static/media/memory.ffa90b57.svg";